"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get getColumnByIdOrName () {
        return getColumnByIdOrName;
    },
    get getViewAndModelByAliasOrId () {
        return getViewAndModelByAliasOrId;
    },
    get serializeCellValue () {
        return serializeCellValue;
    },
    get validateV1V2DataPayloadLimit () {
        return validateV1V2DataPayloadLimit;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _catchError = require("~/helpers/catchError");
const _models = require("~/models");
const _Base = /*#__PURE__*/ _interop_require_default(require("~/models/Base"));
const _constants = require("~/constants");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function getViewAndModelByAliasOrId(context, param) {
    const base = await _Base.default.getWithInfoByTitleOrId(context, param.baseName);
    const model = await _models.Model.getByAliasOrId(context, {
        base_id: base.id,
        aliasOrId: param.tableName
    });
    if (!model) _catchError.NcError.tableNotFound(param.tableName);
    const view = param.viewName && await _models.View.getByTitleOrId(context, {
        titleOrId: param.viewName,
        fk_model_id: model.id
    });
    if (param.viewName && !view) _catchError.NcError.viewNotFound(param.viewName);
    return {
        model,
        view
    };
}
async function serializeCellValue(context, { value, column, siteUrl }) {
    if (!column) {
        return value;
    }
    if (!value) return value;
    switch(column == null ? void 0 : column.uidt){
        case _nocodbsdk.UITypes.Attachment:
            {
                let data = value;
                try {
                    if (typeof value === 'string') {
                        data = JSON.parse(value);
                    }
                    if (!Array.isArray(data)) {
                        data = [
                            data
                        ];
                    }
                } catch (unused) {
                    data = undefined;
                }
                return (data || []).filter((attachment)=>attachment).map((attachment)=>`${attachment.title || 'Attachment'}(${attachment.signedPath ? encodeURI(`${siteUrl}/${attachment.signedPath}`) : attachment.signedUrl})`).join(', ');
            }
        case _nocodbsdk.UITypes.User:
        case _nocodbsdk.UITypes.CreatedBy:
        case _nocodbsdk.UITypes.LastModifiedBy:
            {
                let data = value;
                try {
                    if (typeof value === 'string') {
                        data = JSON.parse(value);
                    }
                } catch (unused) {}
                return (data ? Array.isArray(data) ? data : [
                    data
                ] : []).map((user)=>`${user.email}`).join(', ');
            }
        case _nocodbsdk.UITypes.Lookup:
            {
                const colOptions = await column.getColOptions(context);
                const relationColOptions = await colOptions.getRelationColumn(context).then((col)=>col.getColOptions(context));
                const { refContext } = relationColOptions.getRelContext(context);
                const lookupColumn = await colOptions.getLookupColumn(refContext);
                return (await Promise.all([
                    ...Array.isArray(value) ? value : [
                        value
                    ]
                ].map(async (v)=>serializeCellValue(refContext, {
                        value: v,
                        column: lookupColumn,
                        siteUrl
                    })))).join(', ');
            }
            break;
        case _nocodbsdk.UITypes.LinkToAnotherRecord:
            {
                const colOptions = await column.getColOptions(context);
                const { refContext } = await colOptions.getRelContext(context);
                const relatedModel = await colOptions.getRelatedTable(refContext);
                await relatedModel.getColumns(refContext);
                return [
                    ...Array.isArray(value) ? value : [
                        value
                    ]
                ].map((v)=>{
                    var _relatedModel_displayValue;
                    return v[(_relatedModel_displayValue = relatedModel.displayValue) == null ? void 0 : _relatedModel_displayValue.title];
                }).join(', ');
            }
            break;
        case _nocodbsdk.UITypes.Decimal:
            {
                var _ref;
                var _column_meta;
                if (isNaN(Number(value))) return null;
                return Number(value).toFixed((_ref = (_column_meta = column.meta) == null ? void 0 : _column_meta.precision) != null ? _ref : 1);
            }
            break;
        case _nocodbsdk.UITypes.Duration:
            {
                var _column_meta1;
                if (((_column_meta1 = column.meta) == null ? void 0 : _column_meta1.duration) === undefined) {
                    return value;
                }
                return (0, _nocodbsdk.convertMS2Duration)(value, column.meta.duration);
            }
        default:
            if (value && typeof value === 'object') {
                return JSON.stringify(value);
            }
            return value;
    }
}
async function getColumnByIdOrName(context, columnNameOrId, model) {
    const column = (await model.getColumns(context)).find((c)=>c.title === columnNameOrId || c.id === columnNameOrId || c.column_name === columnNameOrId);
    if (!column) _catchError.NcError.fieldNotFound(columnNameOrId);
    return column;
}
const validateV1V2DataPayloadLimit = (context, param)=>{
    if (context.is_api_token && Array.isArray(param.body) && param.body.length > _constants.V1_V2_DATA_PAYLOAD_LIMIT) {
        _catchError.NcError.get(context).maxPayloadLimitExceeded(_constants.V1_V2_DATA_PAYLOAD_LIMIT);
    }
};
